import { Window } from '@sevenrooms/ui-kit/layout'
import { CreatePriorityAlert } from '../../Reservations/Search/PriorityAlert/CreatePriorityAlert'
import { CreatePriorityAlertSuccessful } from '../../Reservations/Search/PriorityAlert/CreatePriorityAlertSuccessful'
import { CreateRequest } from '../../Reservations/Search/Request/CreateRequest'
import { useModals } from '../../store'
import { RequestOrPriorityAlertButton } from '../RequestOrPriorityAlertButton'

export function RequestOrPriorityAlertAvailability({
  variant,
  partySize,
  startDate,
  requestTimeSlots,
}: {
  requestTimeSlots: string[]
  variant: 'primary' | 'secondary'
  partySize: number
  startDate: string
}) {
  const { showModal, hideModal, activeModal } = useModals()

  return (
    <>
      <RequestOrPriorityAlertButton
        partySize={partySize}
        buttonVariant={variant}
        onRequestButtonClick={() => showModal('createRequest')}
        onPriorityAlertButtonClick={() => showModal('createPriorityAlert')}
      />
      {activeModal === 'createPriorityAlert' && (
        <Window active>
          <CreatePriorityAlert validRequestTimes={requestTimeSlots} partySize={partySize} startDate={startDate} onClose={hideModal} />
        </Window>
      )}
      {activeModal === 'createRequest' && (
        <Window active>
          <CreateRequest validRequestTimes={requestTimeSlots} partySize={partySize} startDate={startDate} onClose={hideModal} />
        </Window>
      )}
      {activeModal === 'createPriorityAlertSuccess' && (
        <Window active>
          <CreatePriorityAlertSuccessful isPriorityAlert partySize={partySize} startDate={startDate} onClose={hideModal} />
        </Window>
      )}
      {activeModal === 'createRequestSuccess' && (
        <Window active>
          <CreatePriorityAlertSuccessful isPriorityAlert={false} partySize={partySize} startDate={startDate} onClose={hideModal} />
        </Window>
      )}
    </>
  )
}
